module.exports = __webpack_public_path__ + "img/ssld.9a362f43.jpg";